// Helpers for the closed-session row correction feature (docs/session-row-correction-frontend.md).
import { normalizeReading, readingFormatError } from '@/utils/readings'

const BLOCKED_MESSAGES = {
  voided: 'This row is already voided.',
  not_round_row: 'Only closed reading-round rows can be corrected.',
  main_meter: "The main meter can't be corrected on its own because it would change every lot's amount. Roll back the whole session instead.",
  newer_session: 'A newer session exists for this lot. Roll back newer sessions first.',
  tanker_fallback: "This tanker round shared its cost by each lot's share of total private consumption, so one lot can't be re-billed without changing everyone else's share. Roll back the whole session and re-close it.",
  tanker_data_unavailable: "This round's tanker data (mains reading and tanker volume) is missing, so a single row can't be corrected. Roll back the whole session and re-close it.",
  building_tier_missing_snapshot: 'This service is billed at building level, but this round was closed before that switch, so there is no blended rate to re-bill with. Roll back the whole session and re-close it.'
}

// Maps a correctBlockedReason / blocked-422 `reason` code to user-facing text. 2026-10-19
export function correctBlockedMessage(code) {
  return BLOCKED_MESSAGES[code] || 'This row cannot be corrected.'
}

// Returns an error string if newReading is invalid for the row, otherwise ''. 2026-10-19
export function validateNewReading(newReading, row) {
  if (newReading === '' || newReading === null || newReading === undefined) return 'Enter the corrected closing reading.'
  const formatError = readingFormatError(newReading)
  if (formatError) return formatError
  const value = Number(normalizeReading(newReading))
  if (row && value < Number(row.previous_unit || 0)) {
    return 'The new reading cannot be below the opening reading (' + Number(row.previous_unit || 0) + ').'
  }
  if (row && value === Number(row.current_unit)) return 'The new reading is the same as the current closing reading.'
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/rowCorrection.js